const ADD_AREA_PATH =
  'M13.2051 3.73438V10.793H20.2637V13.2051H13.2051V20.2637H10.793V13.2051H3.73438V10.793H10.793V3.73438H13.2051Z';

const REMOVE_AREA_PATH =
  'M11.999 9.38281C13.0097 9.38281 13.8851 9.95633 14.3213 10.7949H20.2637V13.2061H14.3213C13.885 14.0446 13.0096 14.6182 11.999 14.6182C10.9884 14.6181 10.113 14.0446 9.67676 13.2061H3.73438V10.7949H9.67676C10.113 9.95632 10.9884 9.38283 11.999 9.38281Z';

const buildCursor = (path: string) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="${path}" fill="black" stroke="white" stroke-width="1" />
    </svg>
  `;

  return `url("data:image/svg+xml;base64,${btoa(svg)}") 12 12, crosshair`;
};

export const ADD_AREA_CURSOR = buildCursor(ADD_AREA_PATH);
export const REMOVE_AREA_CURSOR = buildCursor(REMOVE_AREA_PATH);
